import React, { Component } from "react";

import "./ValidationPill.scss";

export interface ValidationPillProps {
    pattern: RegExp;
    caption: string;
    currentPassword: string;
}

export default class ValidationPill extends Component<ValidationPillProps, {}> {
    render() {
        const valid = this.props.pattern.test(this.props.currentPassword);
        return (
            <div
                className={
                    "password-validator-container " +
                    (valid ? "valid" : "invalid")
                }
            >
                {this.props.caption}
            </div>
        );
    }
}
